import { Helmet } from "react-helmet-async";
import { useState, useEffect } from "react";

const DynamicMetaTags = ({ pageTitle, pageDescription, pageKeywords }) => {
  const [title, setTitle] = useState(pageTitle);
  const [description, setDescription] = useState(pageDescription);
  const [keywords, setKeywords] = useState(pageKeywords);

  useEffect(() => {
    setTitle(pageTitle);
    setDescription(pageDescription);
    setKeywords(pageKeywords);
  }, [pageTitle, pageDescription, pageKeywords]);

  return (
    <div>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://eatexpress-admin-panel.vercel.app"
        />

        <meta
          property="og:title"
          content="Beep - Your Ultimate Delivery Solution for Food!"
        />
        <meta
          property="og:description"
          // content="Transform your logistics operations with our all-in-one Driver & Outlet Management App. Effortlessly handle driver onboarding, outlet registration, order allocations, payment processing, and real-time analytics—all in a user-friendly platform designed for efficiency."
        />
        <meta
          property="og:url"
          content="https://eatexpress-admin-panel.vercel.app"
        />
        <meta property="og:image" content="/assets/og-image" />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Streamline Your Logistics with Our Driver & Outlet Management App"
        />
        <meta
          name="twitter:description"
          content="Optimize your logistics operations with our comprehensive app. Manage drivers, outlets, orders, payments, and gain insights with real-time analytics."
        />
        <meta name="twitter:image" content="/assets/og-image" />
      </Helmet>
    </div>
  );
};

export default DynamicMetaTags;
